import { render } from "./LinkProjectsDialog.vue?vue&type=template&id=5829e07c"
import script from "./LinkProjectsDialog.vue?vue&type=script&lang=js"
export * from "./LinkProjectsDialog.vue?vue&type=script&lang=js"

import "./LinkProjectsDialog.vue?vue&type=style&index=0&id=5829e07c&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__